import React from 'react';
import ReactDOM from 'react-dom';
import { importMap } from './dynamicImportMap';

export const getComponentDetailsFromDOM = (componentName) => {
  try {
  const targetNodeList = document.querySelectorAll(`[data-component="${componentName}"]`);
  const targetNodeArray = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0, ll = targetNodeList.length; i !== ll; targetNodeArray.push(targetNodeList[i++]));
    if (targetNodeArray && targetNodeArray.length) {
      return targetNodeArray.map(targetNode => {
        const props = targetNode.getAttribute('data-props') || null;
        return {
          targetNode,
          props: JSON.parse(props)
        };
      });
    }
  } catch (err) {
    console.error('There was an error when getting component details from DOM for:', { componentName, err });
    return false;
  }
  return false;
};

export const dynamicRender = ({ componentName, eventListener }) => {
  const componentDetailsList = getComponentDetailsFromDOM(componentName);
  if (componentDetailsList && componentDetailsList.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = componentDetailsList.length; i < len; i++) {
      const { targetNode, props } = componentDetailsList[i];
      importMap[componentName]()
        .then((module) => {
          const Component = module[componentName];
          try {
            ReactDOM.render(<Component {...props} />, targetNode);
          } catch (err) {
            console.error('Dynamically loaded component is not valid:', { componentName, err }, Component);
          }
        })
        .catch(err => {
          console.error('Could NOT load the component dynamically:', { componentName, err });
        });
    }
  }
  if (eventListener) {
    document.addEventListener(eventListener, () => {
      dynamicRender({ componentName });
    });
  }
};